import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'

export default {
  namespaced: true,

  state () {
    return {
      module: '',
      fieldName: '',
      bannedWords: [],
      foundryId: '',
      hasBannedWord: false,
    }
  },

  getters: {
    checkForBannedWord: state => {
      return state.hasBannedWord
    }
  },
  
  mutations: {
    setData(state, payload = {}) {
      state.module = payload.module
      state.fieldName = payload.fieldName
      state.bannedWords.push(...payload.bannedWords)
      state.foundryId = payload.foundryId
    },
    setHasBannedWord(state, hasBannedWord) {
      state.hasBannedWord = hasBannedWord;
    },
  },

  actions: {
    async saveBannedWordsToBackend({ commit }, {module, fieldName, bannedWords, foundryId}) {
      try {
        const payload = {
          module: module,
          fieldName: fieldName,
          bannedWords: bannedWords,
          foundryId: foundryId
        }
        const response = await Api.Analytics.logBannedWords(payload)
        if(response.data.success) {
          commit('setData', payload)
        }
        return response.data
      } catch (error) {
        let err = Errors.create(error)
        commit('errors/add', err)
        throw err
      }
    },
  },

  modules: {
    errors: VuexErrors
  }
}
